<template>
  <v-alert
    v-if="text"
    type="success"
    icon="mdi-alert-circle"
  >
    {{ messages[text] }}
  </v-alert>
</template>

<script>
import { messages } from '../common/messages'

export default {
  props: {
    text: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {
      messages
    };
  },
};
</script>

